import { IFoodMenuCategory } from "../../../../redux/food/food.types";

/**
 * Filters categories by search text against category_name (case-insensitive).
 * Returns all categories unchanged if searchText is empty or whitespace-only.
 */
export function filterCategories(
  categories: IFoodMenuCategory[],
  searchText: string
): IFoodMenuCategory[] {
  if (!searchText.trim()) return categories;
  const lower = searchText.toLowerCase();
  return categories.filter((cat) =>
    cat.category_name.toLowerCase().includes(lower)
  );
}
